import React from 'react';
import Main from './components/Main';
import './index.scss';

const HiboTian = () => {
    return (
        <div>
            <Main />
        </div>
    )
}
export default HiboTian
